// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"fe0293d29a25c26c","9190":"42d90f297e4fd06f"}[chunkId] + ".css";
};